import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormBuilder } from '@angular/forms';
import { SpinnerService } from '@shared/services/spinner.service';
import { ApiService } from '@shared/apis';
import { Subject } from 'rxjs';

export interface timelineModel {
  status: string;
  reason?: string;
  description: string;
  active?: boolean;
  isCancelled?: boolean;
}


@Component({
  selector: 'app-repair-status',
  templateUrl: './repair-status.component.html',
  styleUrls: ['./repair-status.component.scss']
})
export class RepairStatusComponent implements OnInit {
  title: any;
  ticket: any;
  timelineData!: timelineModel[];
  processType: any;
  detailType: any;
  ticketType: any;
  status: any;

  reasonList: any = [];

  cancelledStatus = ['ST050', 'ST051', 'ST052', 'ES080', 'ES090'];
  dangerStatus = ['ST030', 'ST033'];

  public onClose: Subject<any>;

  constructor(private bsModalRef: BsModalRef,
              private fb: FormBuilder,
              private spinnerService: SpinnerService,
              private modalService: BsModalService,
              private apiService: ApiService,
  ) {
  }

  ngOnInit(): void {
    console.log('title = ', this.title, ', status =', this.status, ', processType =', this.processType, ', detailType =', this.detailType);
    this.setTimelineData();
    this.onClose = new Subject();
  }

  setTimelineData() {
    const statusData = this.processType === 'ZR01' ? this.statusData[this.processType] : this.statusData[this.processType][this.detailType];
    this.timelineData = statusData.filter(f => {
        return !f.isCancelled || f.status === this.status
        }).map(m => {
        if (m.status === this.status) {
            m.active = true;
          }
        return m;
      });
  }

  statusData = {
    ZR01: [
      {
        status: 'E0001',
        description: 'Pending',
        active: false,
        isCancelled: false,
      }, {
        status: 'E0002',
        description: 'Transfer',
        active: false,
        isCancelled: false,
      }, {
        status: 'E0003',
        description: 'Cancel',
        active: false,
        isCancelled: false,
      }, {
        status: 'E0004',
        description: 'Closed',
        active: false,
        isCancelled: false,
      }
    ],
    ZS01: {
      DET001: [
        {
          status: 'ST005',
          description: 'ASC not available',
          active: false,
          isCancelled: false,
        }, {
          status: 'ST010',
          description: 'Assigned to Service Center',
          active: false,
          isCancelled: false,
        }, {
          status: 'ST015',
          description: 'Acknowledge (ASC)',
          active: false,
          isCancelled: false,
        }, {
          status: 'ST025',
          description: 'Engineer Assigned',
          active: false,
          isCancelled: false,
        }, {
          status: 'ST030',
          description: 'Pending',
          active: false,
          isCancelled: false,
        }, {
          status: 'ST033',
          description: 'ASC Decline',
          active: false,
          isCancelled: false,
        }, {
          status: 'ST035',
          description: 'Repair Completed',
          active: false,
          isCancelled: false,
        }, {
          status: 'ST040',
          description: 'Goods Delivered / Warranty ',
          active: false,
          isCancelled: false,
        }, {
          status: 'ST050',
          description: 'Cancelled by Triage group',
          active: false,
          isCancelled: true,
        }, {
          status: 'ST051',
          description: 'Cancelled by Agent',
          active: false,
          isCancelled: true,
        }, {
          status: 'ST052',
          description: 'Cancelled by ASC',
          active: false,
          isCancelled: true,
        },
      ],
      DET002: [
        {
          status: 'ES005',
          description: 'Exchange Order Created',
          active: false,
          isCancelled: false,
        }, {
          status: 'ES010',
          description: 'Waiting for GRMS/RMA approval',
          active: false,
          isCancelled: false,
        }, {
          status: 'ES015',
          description: 'GRMS/RMA approved',
          active: false,
          isCancelled: false,
        }, {
          status: 'ES020',
          description: 'S/O Created',
          active: false,
          isCancelled: false,
        }, {
          status: 'ES025',
          description: 'D/O Created',
          active: false,
          isCancelled: false,
        }, {
          status: 'ES030_IN_TRANSIT',
          description: 'In Transit',
          active: false,
          isCancelled: false,
        }, {
          status: 'ES030_DELIVERED',
          description: 'Delivered',
          active: false,
          isCancelled: false,
        }, {
          status: 'ES030_COMPLETE',
          description: 'Exchange Complete',
          active: false,
          isCancelled: false,
        }, {
          status: 'ES040',
          description: 'Exchange Complete',
          active: false,
          isCancelled: false,
        }, {
          status: 'ES080',
          description: 'Cancel',
          active: false,
          isCancelled: true,
        }, {
          status: 'ES090',
          description: 'Reject',
          active: false,
          isCancelled: true,
        }, {
          status: 'REJECTED',
          description: 'Request Reject',
          active: false,
          isCancelled: true,
        },
      ]
    }
  }

  cancel() {
    this.bsModalRef.hide();
  }

}
